export const MAX_TASK_RUN_SECONDS = 5 * 60 * 60;

export const advanceTaskTimer = (task, now) => {
  if (task.isTimerLocked || !task.isTaskRunning) return task;
  if (!Number.isFinite(task.timerUpdatedAt)) {
    return { ...task, timerUpdatedAt: now };
  }
  const runStartedAt = Number.isFinite(task.timerRunStartedAt)
    ? task.timerRunStartedAt : task.timerUpdatedAt;
  const deadline = runStartedAt + MAX_TASK_RUN_SECONDS * 1000;
  const isTimerLocked = now >= deadline;
  const elapsed = Math.max(0, Math.floor((Math.min(now, deadline) - task.timerUpdatedAt) / 1000));
  if (!elapsed && !isTimerLocked) return task;
  return {
    ...task,
    timerRunStartedAt: runStartedAt,
    isTimerLocked,
    isTaskRunning: !isTimerLocked,
    remainingTime: task.remainingTime - elapsed,
    snoozeTimer: Math.max(0, (task.snoozeTimer || 0) - elapsed),
    timerUpdatedAt: task.timerUpdatedAt + elapsed * 1000,
  };
};

// Return one alert after a delayed tick, rather than replaying every missed beep.
export const getTaskAlert = (previous, current, warningSeconds, isBreak, isAutoMode = false) => {
  if (current.snoozeTimer > 0) return null;
  if (current.remainingTime >= previous.remainingTime) return null;
  const before = previous.remainingTime;
  const after = current.remainingTime;
  if (isAutoMode) {
    // Crossed thresholds also handle delayed ticks without replaying missed beeps.
    return after > 0 && [5, 3, 1].some((seconds) => before > seconds && after <= seconds)
      ? "beep" : null;
  }
  if (before > 0 && after <= 0) return "due";
  if (after < -5 && current.snoozeTimer <= 0) {
    const overdue = Math.abs(after);
    const previousOverdue = Math.max(0, -before);
    const crossed = (seconds) =>
      Math.floor(overdue / seconds) > Math.floor(previousOverdue / seconds);
    if (isBreak && crossed(20)) return "due";
    if (!isBreak && crossed(120)) return "negative";
    if (crossed(5)) return "beep";
  }
  const warning = Number(warningSeconds);
  if (after > 0 && Number.isFinite(warning) && warning > 0 && after <= warning) {
    return before > warning ||
      Math.floor((warning - after) / 2) > Math.floor((warning - before) / 2)
      ? "beep" : null;
  }
  if (before > 121 && after <= 121 && after > 0) return "early";
  return null;
};


export const isTaskWarningActive = (task, warningSeconds) =>
  task.isTaskRunning && !task.isTimerLocked && !task.isCompleted &&
  (task.snoozeTimer || 0) <= 0 &&
  (task.remainingTime < 0 || (Number(warningSeconds) > 0 && task.remainingTime <= Number(warningSeconds)));
